import { Tooltip } from "@design-system/DataDisplay/Tooltip";
import { Textarea } from "@design-system/Inputs/Textarea";
import { Textfield } from "@design-system/Inputs/Textfield";
import { Box } from "@design-system/Layout/Box";
import { FlexCol } from "@design-system/Layout/Flex";
import { Modal } from "@design-system/Modal";
import { ChangeEvent } from "react";
import { useKnowledgeBasePageTranslations } from "../../i18n";
export const AddCustomItemModal = ({
    open,
    onOpenChange,
    onSave,
    description,
    onDescriptionChange,
    value,
    onValueChange,
}: {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    onSave: (
        description: string | undefined,
        value: string | undefined,
    ) => void;
    description: string | undefined;
    onDescriptionChange: (description?: string) => void;
    value: string | undefined;
    onValueChange: (value?: string) => void;
}) => {
    const { t, keys } = useKnowledgeBasePageTranslations();

    const handleDescriptionChange = (e: ChangeEvent<HTMLInputElement>) => {
        onDescriptionChange?.(e.target.value);
    };
    const handleValueChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
        onValueChange?.(e.target.value);
    };

    const handleSave = () => {
        onSave(description, value);
    };

    return (
        <Modal open={open} onOpenChange={onOpenChange}>
            <Modal.Overlay centerContent>
                <Modal.Content className="max-w-[600px] w-full">
                    <Modal.Header withClose>
                        <Modal.Title>{t(keys.add_custom_item)}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="flex flex-col gap-4">
                        <FlexCol>
                            <Textfield
                                placeholder={t(keys.custom_item_description)}
                                value={description}
                                onChange={handleDescriptionChange}
                                required
                            />
                        </FlexCol>
                        <FlexCol>
                            <Textarea
                                placeholder={t(keys.custom_item_value)}
                                value={value}
                                onChange={handleValueChange}
                                rows={3}
                            />
                        </FlexCol>
                    </Modal.Body>
                    <Modal.Footer>
                        <Modal.CancelCTA>{t(keys.cancel)}</Modal.CancelCTA>
                        <Tooltip>
                            <Tooltip.Trigger asChild>
                                <Box>
                                    <Modal.ConfirmCTA
                                        onClick={handleSave}
                                        preventClose={false}
                                        disabled={!description}
                                    >
                                        {t(keys.save_custom_item)}
                                    </Modal.ConfirmCTA>
                                </Box>
                            </Tooltip.Trigger>
                            {!description && (
                                <Tooltip.Content>
                                    {t(keys.custom_item_description_error)}
                                </Tooltip.Content>
                            )}
                        </Tooltip>
                    </Modal.Footer>
                </Modal.Content>
            </Modal.Overlay>
        </Modal>
    );
};
